import { render, staticRenderFns } from "./DepartmentAddView.vue?vue&type=template&id=b39fb316"
import script from "./DepartmentAddView.vue?vue&type=script&lang=js"
export * from "./DepartmentAddView.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAddView.vue?vue&type=style&index=0&id=b39fb316&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports